import { QuoteRequestDTO } from '@luminovo/api-contracts';

import { formatSupplierDTO } from './formatSupplierAndStockLocation';

export function formatQuoteRequest(quoteRequest: QuoteRequestDTO) {
    return `${formatSupplierDTO(quoteRequest.supplier)} # ${quoteRequest.number}`;
}
